import React, { useState } from "react";
import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

function HomeForm() {
  const [formData, setFormData] = useState({
    name: "",
    city: "",
    mobile: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "contacts"), {
        name: formData.name,
        mobile: formData.mobile,
        city: formData.city,
        message: formData.message,
        createdAt: serverTimestamp(),
      });

      alert("Submitted Successfully");

      setFormData({
        name: "",
        city: "",
        mobile: "",
        message: "",
      });
    } catch (error) {
      alert("Error saving data: " + error.message);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        className="me-2 mt-2"
        type="text"
        name="name"
        placeholder="Name"
        value={formData.name}
        onChange={handleChange}
        required
      />

      <input
        className="me-2 mt-2"
        type="tel"
        name="mobile"
        placeholder="Mobile No."
        value={formData.mobile}
        onChange={handleChange}
        required
      />

      <input
        className="me-2 mt-2"
        type="text"
        name="city"
        placeholder="City"
        value={formData.city}
        onChange={handleChange}
        required
      />

      <textarea
        className="me-2 mt-2"
        name="message"
        placeholder="Land queries details..."
        value={formData.message}
        onChange={handleChange}
        required
      />

      <center>
        <button className="landmessage mt-3" type="submit">
          Submit
        </button>
      </center>
    </form>
  );
}

export default HomeForm;